import React, { useState, useEffect } from 'react'
import MedicalHistorySection from '../../../components/ProfileForm/MedicalHistorySection'

const HealthInfo = ({ data, onChange, onValidityChange, dependant }) => {
  const [userInfo, setUserInfo] = useState({
    medicalHistory: {
      allergies: { preferNotToSay: false, noKnownAllergies: false, value:'' },
      medications: { takingNone: false, preferNotToSay: false, value: '' },
      conditions: {
        noKnownConditions: false,
        preferNotToSay: false,
        value: ''
      },
    },
  })

  const [emergencyContact, setEmergencyContact] = useState({
    emergencyName: data.emergencyName || '',
    emergencyPhone: data.emergencyPhone || '',
  })

  const [consent, setConsent] = useState({
    consent: data.consent || false,
    terms: data.terms || false,
  })

  const validate = () => {
    return (
      consent.consent &&
      consent.terms &&
      emergencyContact.emergencyName.trim() &&
      emergencyContact.emergencyPhone.trim()
    )
  }

  useEffect(() => {
    const isValid = validate()
    if (typeof onValidityChange === 'function') {
      onValidityChange(isValid)
    }

    // Update parent component with current data
    onChange('emergencyName', emergencyContact.emergencyName)
    onChange('emergencyPhone', emergencyContact.emergencyPhone)
    onChange('consent', consent.consent)
    onChange('terms', consent.terms)
    onChange('medicalHistory', userInfo.medicalHistory)
  }, [userInfo, emergencyContact, consent])

  return (
    <div className="space-y-6">
      {/* Medical History Section */}
      <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-6 sm:gap-x-6">
        <MedicalHistorySection
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          showTitle={true}
          dependant={dependant}
        />
      </div>

      {/* Emergency Contact */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Emergency Contact</h2>

        <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-6 sm:gap-x-6">
          <div className="sm:col-span-3">
            <label
              htmlFor="emergencyName"
              className="block text-sm/6 font-medium"
            >
              Name
            </label>
            <input
              type="text"
              id="emergencyName"
              name="emergencyName"
              required
              value={emergencyContact.emergencyName}
              onChange={(e) => {
                setEmergencyContact((prev) => ({
                  ...prev,
                  emergencyName: e.target.value,
                }))
              }}
              placeholder="Jane Smith"
              className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
            />
          </div>

          <div className="sm:col-span-3">
            <label
              htmlFor="emergencyPhone"
              className="block text-sm/6 font-medium"
            >
              Phone Number
            </label>
            <input
              type="tel"
              id="emergencyPhone"
              name="emergencyPhone"
              required
              value={emergencyContact.emergencyPhone}
              onChange={(e) => {
                setEmergencyContact((prev) => ({
                  ...prev,
                  emergencyPhone: e.target.value,
                }))
              }}
              placeholder="07700 900456"
              className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
            />
          </div>
        </div>
      </div>

      {/* Consent */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Consent</h2>

        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="consent"
              name="consent"
              required
              checked={consent.consent}
              onChange={(e) => {
                setConsent((prev) => ({ ...prev, consent: e.target.checked }))
              }}
              className="h-4 w-4 text-violet-600"
            />
            <label htmlFor="consent" className="text-sm text-gray-600">
              I consent to the storage and sharing of my {dependant && 'dependants'} data for the purpose of
              receiving wellbeing services.
            </label>
          </div>

          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="terms"
              name="terms"
              checked={consent.terms}
              onChange={(e) => {
                setConsent((prev) => ({ ...prev, terms: e.target.checked }))
              }}
              required
              className="h-4 w-4 text-violet-600"
            />
            <label htmlFor="terms" className="text-sm text-gray-600">
              I agree to the{' '}
              <a href="/privacy-policy" target="_blank" className="underline text-violet-600">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href="/terms" target='_blank' className="underline text-violet-600">
                Terms of Use
              </a>
              .
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HealthInfo
